import { trackClientEvent } from 'analytics/analytics'

const BOT_DETECTION_TRACKED_KEY = 'lab_bot_detection_tracked'

/**
 * Temporary instrumentation: fires when a Lab call is skipped for a bot.
 * Prefer calling from Lab action guards only — not as a general bot detector.
 */
export function trackLabBotDetectionEvent(userAgent: string): void {
  if (typeof window === 'undefined') return

  try {
    if (sessionStorage.getItem(BOT_DETECTION_TRACKED_KEY)) return
    sessionStorage.setItem(BOT_DETECTION_TRACKED_KEY, '1')
  } catch {
    // sessionStorage may be unavailable in some environments
  }

  trackClientEvent({
    subject: 'lab_bot_detection',
    action: userAgent,
    category: 'lab',
    type: 'nonInteraction',
  })
}
